const passwordValidationRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&.])[A-Za-z\d@#$!%*?&.]{12,}$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const validateEmail = (email, translate) => {
  email = email.trim();
  if (!email) return translate('authForm.emailRequired');
  if (!emailRegex.test(email)) return translate('authForm.invalidEmail');
  return '';
};

export const validatePassword = (password, state, translate) => {
  if (!password) return translate('authForm.passwordRequired');
  if (!passwordValidationRegex.test(password) && state !== 'LOGIN') {
    return translate('authForm.invalidPassword');
  }
  return '';
};

export const checkPasswordConditions = (password) => {
  if (!password) {
    return {
      length: false,
      hasNumber: false,
      hasSpecialChar: false,
      hasUppercase: false,
      hasLowercase: false,
    };
  }
  return {
    length: password.length >= 12,
    hasNumber: /\d/.test(password),
    hasSpecialChar: /[@#$!%*?&.]/.test(password),
    hasUppercase: /[A-Z]/.test(password),
    hasLowercase: /[a-z]/.test(password),
  };
};
